import { firestoreTimestamp } from "@/firebaseConfig";
import { saveLog } from "@/collections/logs";
import { savePrinterError } from "@/collections/printerErrors";
import { savePrinterHistory } from "@/collections/printerHistory";

export default {
  methods: {
    async showSuccessMessage(title) {
      // eslint-disable-next-line no-undef
      Toast.fire({
        type: "success",
        title: title
      });
    },
    async showInfoMessage(title) {
      // eslint-disable-next-line no-undef
      Toast.fire({
        type: "info",
        title: title
      });
    },
    async showErrorMessage(title) {
      // eslint-disable-next-line no-undef
      Toast.fire({
        type: "error",
        title: title
      });
    },
    async setlogInfo(context, message, data, component = "") {
      saveLog(this.buildLog("INFO", context, message, data, component));
    },
    async setlogError(context, message, data, component = "") {
      saveLog(this.buildLog("ERROR", context, message, data, component));
    },
    buildLog(level, context, message, data, component) {
      return {
        time: new Date(),
        level: level,
        context: context,
        message: message,
        data: data,
        referer: document.referrer,
        userAgent: navigator.userAgent,
        component: component
      };
    },
    async setPrinterInfo(id, printerUrl, printerName, data, groupId) {
      let logObj = this.buildPrinterLog(
        id,
        printerUrl,
        printerName,
        data,
        groupId
      );
      savePrinterHistory(logObj);
    },
    async setPrinterError(id, printerUrl, printerName, data, groupId) {
      let logObj = this.buildPrinterLog(
        id,
        printerUrl,
        printerName,
        data,
        groupId
      );
      savePrinterError(logObj);
    },
    buildPrinterLog(id, printerUrl, printerName, data, groupId) {
      let logObj = {
        time: this.formatDateTime(firestoreTimestamp.fromDate(new Date()).time),
        id,
        printerUrl,
        printerName,
        data,
        groupId,
        status: true,
        referer: document.referrer,
        userAgent: navigator.userAgent
      };

      // replace undefined with null to handle exception
      logObj = JSON.stringify(logObj, (_key, value) =>
        value === undefined ? null : value
      );
      return JSON.parse(logObj);
    }
  }
};
